import axios from "axios";

//axios instance
const ajaxInstance = axios.create({
    timeout: 1000,
    withCredentials: true,
})

export {
    ajaxInstance
}